import PropTypes from 'prop-types';
import { Cushion, FlexContainer, Space, Typography, Rectangle, Shadow } from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import React from 'react';
import Icon from '../icon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { Trans } from '../../lib/i18n';

const Overview = ({ club, isCancelled, name, start, end }) => {
  const startTime = DateTime.fromISO(start).setZone(club.timezone);
  const endTime = DateTime.fromISO(end).setZone(club.timezone);

  return (
    <Shadow>
      <Rectangle fill="white" radius="rounded">
        <Cushion
          className="training-overview"
          all="large"
          style={{ gridArea: 'overview' }}
          component="div"
        >
          <Space bottom="small">
            <FlexContainer justifyContent="space-between">
              <Typography preset="tab--active">{name}</Typography>
              <Icon name="training" color="dustygrey" size={32} />
            </FlexContainer>
          </Space>

          <FlexContainer justifyContent="space-between">
            <Typography preset="tag--large" color="dustygrey">
              {startTime.toFormat('ccc dd, MMM yy')}
            </Typography>
            <Typography preset="tag--large" color={isCancelled ? 'negative' : 'dustygrey'}>
              {isCancelled ? (
                <Trans i18nKey="common:training_cancelled">Cancelled</Trans>
              ) : (
                `${startTime.toFormat('HH:mm')} - ${endTime.toFormat('HH:mm')}`
              )}
            </Typography>
          </FlexContainer>
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

Overview.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  isCancelled: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
};

export default Overview;
